import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    getSmsAliasGetSMSList: (idMessage) => `${baseURL}/api/smsalias`
  }
})(process.env.BESMSALIAS_URL)

export const beSmsAliasGetSMSList = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsAliasGetSMSList(idMessage),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}
